import { render, staticRenderFns } from "./product-extended-information-link.vue?vue&type=template&id=97140c24&"
import script from "./product-extended-information-link.vue?vue&type=script&lang=js&"
export * from "./product-extended-information-link.vue?vue&type=script&lang=js&"
import style0 from "./product-extended-information-link.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports